module.exports = __webpack_public_path__ + "static/about-us-5e7059397f93ebf5901a0437ccd433a8.jpg";